import { Box, Flex, FlexProps, Image, Skeleton } from '@chakra-ui/react';
import { PIXEL_IMAGE } from '~/constants';
import { getRandomIntFromInterval } from '~/utils-ts';

interface IContentSearchSkeleton extends FlexProps {
  items?: number;
  maxHeight?: number;
}

export const ContentSearchSkeleton: React.FC<IContentSearchSkeleton> = ({
  items = 10,
  maxHeight = 260,
  ...flexProps
}) => {
  const ratio = [
    {
      aspectRatio: '1 / 1',
    },
    {
      aspectRatio: '16 / 9',
    },
    {
      aspectRatio: '9 / 16',
    },
  ] as const;

  return (
    <Flex
      flexWrap="wrap"
      gap={2}
      sx={{
        ':after': {
          content: '""',
          flexGrow: 999,
        },
      }}
      maxHeight="calc(2 * 300px)"
      overflow="hidden"
      {...flexProps}
    >
      {Array.from(Array(items).keys()).map((index) => (
        <Box
          position="relative"
          cursor="pointer"
          flex="1 1 auto"
          height={maxHeight}
          marginBottom={10}
          key={index}
        >
          <Image
            width="100%"
            height="100%"
            objectFit="cover"
            src={PIXEL_IMAGE}
            alt="Skeleton"
            borderRadius="lg"
            sx={{
              ...ratio[getRandomIntFromInterval(0, ratio.length)],
            }}
          />
          <Skeleton
            position="absolute"
            top={0}
            left={0}
            width="100%"
            height="100%"
            borderRadius="lg"
            startColor="primary.50"
            endColor="primary.100"
          />
        </Box>
      ))}
    </Flex>
  );
};
